import { BASE_URL, COUNTRY, WORKSHOP_INVITATION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IWorkshopInvitationResponseInput, IWorkshopInvitationsInput } from "models/workshopInvitations";

export async function getInvitations(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_INVITATION + params);
  return response.data;
}
export async function addInvitation(data: IWorkshopInvitationsInput) {
  const response = await axios.post(BASE_URL + WORKSHOP_INVITATION, data);
  return response.data;
}

export async function addInvitationForGroupWorkshops() {
  const response = await axios.post(BASE_URL + WORKSHOP_INVITATION + '/byworkshopgroup');
  return response.data;
}

export async function deleteInvitation(id: string) {
  const response = await axios.delete(BASE_URL + WORKSHOP_INVITATION + "/" + id);
  return response.data;
}

export async function getUninvitedEmployeesAsync(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_INVITATION + "/getUninvitedEmployees" + params);
  return response.data;
}

export async function getInvitationDetails(id: string) {
  const response = await axios.get(BASE_URL + WORKSHOP_INVITATION + '/' + id);
  return response.data;
}

export async function respondToInvitation(data: IWorkshopInvitationResponseInput, id: string) {
  const response = await axios.patch(BASE_URL + WORKSHOP_INVITATION + "/" + id, data);
  return response.data;
}

export const InvitationCells: HeadCell[] = [
  {
    id: "employeeName",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "employeeEmail",
    numeric: false,
    disablePadding: false,
    label: "T_email",
  },
  {
    id: "employeeId",
    numeric: false,
    disablePadding: false,
    label: "T_employee_id",
  },
  {
    id: "departmentName",
    numeric: false,
    disablePadding: false,
    label: "T_department",
  },
  {
    id: "statusString",
    numeric: false,
    disablePadding: false,
    label: "T_status",
  },
  {
    id: "rejectionReason",
    numeric: false,
    disablePadding: false,
    label: "T_rejection",
  },
  {
    id: "createdOn",
    numeric: false,
    disablePadding: false,
    label: "T_created_on",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];

export const SelectedEmployeesForInvitationCells: HeadCell[] = [
  {
    id: "employeeName",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "departmentName",
    numeric: false,
    disablePadding: false,
    label: "T_department",
  },
  {
    id: "competencies",
    numeric: false,
    disablePadding: false,
    label: "T_acquired_competencies",
  }
]